<template>
  <div class="wish-list-container">
    <!-- 顶部信息栏 -->
    <div class="header">
      <div class="balance">余额：¥{{ balance }}</div>
      <div class="loan">负债：¥{{ loan }}</div>
      <el-button type="primary" size="small" @click="showAddDialog = true" class="add-btn">
        添加愿望单
      </el-button>
    </div>

    <!-- 愿望单列表 -->
    <div class="wish-list">
      <div v-for="wish in wishList" :key="wish.id" class="wish-item" @click="handleWishClick(wish)">
        <div class="wish-name">{{ wish.wish }}</div>
        <div class="wish-cost">¥{{ wish.cost }}</div>
      </div>
      <div v-if="wishList.length === 0" class="empty-tip">暂无愿望单</div>
    </div>

    <!-- 添加愿望对话框 -->
    <el-dialog title="添加愿望" :visible.sync="showAddDialog" width="300px" custom-class="wish-dialog">
      <el-form :model="newWish" label-width="80px">
        <el-form-item label="愿望名称">
          <el-input v-model="newWish.wish" placeholder="请输入愿望名称"></el-input>
        </el-form-item>
        <el-form-item label="所需金额">
          <el-input v-model.number="newWish.cost" type="number" placeholder="请输入金额" min="0.01"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="addWish">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WishList',
  data() {
    return {
      balance: 0, // 初始余额
      loan: 0, // 初始负债
      wishList: [],
      showAddDialog: false,
      newWish: {
        wish: '',
        cost: null,
      },
      nextId: 1,
    };
  },
  mounted() {
    this.getWishList()
    this.getUserInfo()
  },
  methods: {
    getWishList() {
      fetch('/getWishList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      }).then(response => {
        if (!response.ok) {
          console.error('请求失败', response)
          return []
        }
        return response.json();
      }).then(response => {
        console.log(response)
        if (response.code != 10000) {
          console.error('请求失败 /getWishList/')
          return
        }
        this.wishList = response.data
      }).catch(error => {
        console.error('There was a problem with the fetch  operation:', error);
      });
    },

    getUserInfo() {
      fetch('/getUserInfo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({id: 1})
      }).then(response => {
        if (!response.ok) {
          console.error('请求失败', response)
          return []
        }
        return response.json();
      }).then(response => {
        console.log(response)
        if (response.code != 10000) {
          console.error('请求失败 /getWishList/')
          return
        }
        this.userInfo = response.data
        this.balance = this.userInfo.balance
        this.loan = this.userInfo.loan
      }).catch(error => {
        console.error('There was a problem with the fetch  operation:', error);
      });
    },

    async addWish() {
      if (!this.newWish.wish || !this.newWish.cost || this.newWish.cost <= 0) {
        this.$message.warning('请输入有效的愿望名称和金额');
        return;
      }

      fetch('/addWish', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.newWish)
      }).then(response => {
        if (!response.ok) {
          console.error('请求失败', response)
          return []
        }
        return response.json();
      }).then(response => {
        console.log(response)
        if (response.code != 10000) {
          console.error('请求失败 /addWish/')
          return null
        }
        this.$message.success('愿望添加成功！');
        this.newWish = { wish: '', cost: null };
        this.showAddDialog = false;
        this.getWishList()
      }).catch(error => {
        console.error('There was a problem with the fetch  operation:', error);
      });
    },

    async handleWishClick(wish) {
      const confirm = await this.$confirm(
        `确定要实现愿望「${wish.wish}」吗？将扣除 ¥${wish.cost}`,
        '消费确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch(() => { });

      if (!confirm) return;

      if (this.balance >= wish.cost) {
        // 余额足够
        this.balance -= wish.cost;
        await this.removeWishFromBackend(wish.id);
      } else {
        // 余额不足，询问是否贷款
        const loanConfirm = await this.$confirm(
          `余额不足！是否贷款 ¥${wish.cost} 来实现该愿望？`,
          '贷款提示',
          {
            confirmButtonText: '贷款实现',
            cancelButtonText: '取消',
            type: 'error',
          }
        ).catch(() => { });

        if (loanConfirm) {
          this.loan += wish.cost;
          this.balance -= wish.cost; // 实际消费，余额可能为负（或你可设为0）
          await this.removeWishFromBackend(wish.id);
          await this.recordLoan(wish.cost);
        }
      }
    },

    async removeWishFromBackend(id) {
      console.log(id)
      fetch('/consumeWish', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: id })
      }).then(response => {
        if (!response.ok) {
          console.error('请求失败', response)
          return []
        }
        return response.json();
      }).then(response => {
        console.log(response)
        if (response.code != 10000) {
          console.error('请求失败 /getWishList/')
          return
        }
        this.getWishList()
        this.getUserInfo()
      }).catch(error => {
        console.error('There was a problem with the fetch  operation:', error);
      });
    },

    async recordLoan(cost) {
      console.log(cost)
    },
  },
};
</script>

<style scoped>
.wish-list-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #fdf6f9, #f5f0ff);
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

/* 顶部栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(230, 180, 255, 0.4);
  margin-bottom: 24px;
}

.balance,
.loan {
  font-weight: 600;
  font-size: 16px;
}

.balance {
  color: #e91e63;
  /* 粉色 */
}

.loan {
  color: #9c27b0;
  /* 紫色 */
}

.add-btn {
  background: linear-gradient(to right, #e91e63, #9c27b0);
  border: none;
  color: white;
}

.add-btn:hover {
  opacity: 0.9;
}

/* 愿望列表 */
.wish-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wish-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(233, 30, 99, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.wish-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(156, 39, 176, 0.2);
}

.wish-name {
  font-size: 16px;
  color: #555;
}

.wish-cost {
  font-weight: bold;
  color: #e91e63;
}

.empty-tip {
  text-align: center;
  color: #aaa;
  font-style: italic;
  margin-top: 40px;
}

/* 对话框美化 */
.wish-dialog ::v-deep .el-dialog {
  border-radius: 16px;
  border: none;
}

.wish-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(to right, #e91e63, #9c27b0);
  color: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.wish-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
</style>